/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductsService {
    /**
     * Get all products
     * @returns any Products retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Products(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/products',
        });
    }
    /**
     * Create a new product
     * @param requestBody
     * @returns any Product created successfully
     * @throws ApiError
     */
    public static postApiV2Products(
        requestBody: {
            categoryname?: string;
            itemname?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/products',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get products by category
     * @param category
     * @returns any Products retrieved successfully
     * @throws ApiError
     */
    public static getApiV2ProductsCategory(
        category: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/products/category/{category}',
            path: {
                'category': category,
            },
        });
    }
    /**
     * Get product by ID
     * @param id
     * @returns any Product retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Products1(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/products/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a product
     * @param id
     * @param requestBody
     * @returns any Product updated successfully
     * @throws ApiError
     */
    public static putApiV2Products(
        id: number,
        requestBody: {
            categoryname?: string;
            itemname?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v2/products/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a product
     * @param id
     * @returns any Product deleted successfully
     * @throws ApiError
     */
    public static deleteApiV2Products(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v2/products/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get products by location ID
     * @param id
     * @returns any Products retrieved successfully
     * @throws ApiError
     */
    public static getApiV2ProductsLocation(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/products/location/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Add products to location
     * @param id
     * @param requestBody
     * @returns any Products added successfully
     * @throws ApiError
     */
    public static postApiV2ProductsLocation(
        id: number,
        requestBody: {
            products?: Array<number>;
            buying?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/products/location/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove products from location
     * @param id
     * @param requestBody
     * @returns any Products removed successfully
     * @throws ApiError
     */
    public static deleteApiV2ProductsLocation(
        id: number,
        requestBody: {
            products?: Array<number>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v2/products/location/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
